module.exports = __webpack_public_path__ + "static/media/orange_circle.8b5ae2c2.png";